<template>
    <div class="welcome-message">
        <div class="welcome-message-content">
            <h1 class="title">{{ $t('welcome.title') }}</h1>
            <p class="subtitle">{{ $t('welcome.subtitle') }}</p>
            <p class="description">
                {{ $t('welcome.description') }}</p>

            <div class="question-hints">
                <p class="hint-title">{{ $t('welcome.hintTitle') }}</p>
                <div class="hint-items" v-for="(item, index) in localizedHints" :key="index" @click="handleHintClick(item)">
                    <div class="hint-item">{{ item }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 组件逻辑
export default {
    computed: {
        localizedHints() {
            return this.$t('welcome.hints');
        }
    },
    methods: {
        handleHintClick(title) {
            // 触发自定义事件并传递标题
            this.$emit('hint-selected', title);
        }
    }
}
</script>

<style scoped>
/* 欢迎页样式 */
.welcome-message {
    width: 100%;
    margin: 20px 0 0 0; /* Reduced from 100px to 60px */
    display: flex;
    justify-content: center;
}

.welcome-message-content {
    width: 100%; /* Use full width up to max-width */
    max-width: 879px; /* Keep the desired max width */
    padding: 0 20px; /* Add padding for smaller screens */
    box-sizing: border-box;
    text-align: left; /* Align text left */
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Align items to start (left) */
}

.title {
    width: auto; /* Remove fixed width */
    max-width: 100%;
    height: auto;
    font-family: FZLTTHK--GBK1, FZLTTHK--GBK1;
    font-weight: bold;
    font-size: 36px;
    color: #303030;
    line-height: 1.4;
    margin-bottom: 9px;
}

.subtitle {
    width: auto;
    max-width: 100%;
    height: auto;
    font-weight: 600;
    font-size: 20px;
    color: #6A6A6A;
    line-height: 1.4;
    margin-bottom: 10px;
}

.description {
    width: 100%;
    max-width: 700px;
    height: auto;
    font-weight: 400;
    font-size: 15px;
    color: #888888;
    line-height: 1.6;
    text-align: left; /* Ensure description is left aligned */
    font-style: normal;
    margin-bottom: 20px;
}

.question-hints {
    margin-top: 10px; /* Reduced from 30px */
    text-align: left;
    width: 100%;
    max-width: 700px; /* Align with description width */
}

.hint-title {
    width: auto;
    height: auto;
    font-weight: 400;
    font-size: 16px;
    color: #A0A0A0;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    margin-bottom: 18px;
    margin-top: 0; /* Removed top margin (was 30px) */
}

.hint-items {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
}

.hint-item {
    background: #F3F3F3;
    border-radius: 10px;
    padding: 12px 20px;
    color: #333;
    max-width: 80%;
    cursor: pointer;
    transition: background-color 0.2s;
    margin-bottom: 10px;


    font-weight: 400;
    font-size: 16px;
    color: #303030;
    line-height: 22px;
    font-style: normal;
}

.hint-item:hover {
    background-color: #e6e6e6;
}

@media (max-width: 768px) {
    .welcome-message-content {
        max-width: 95%;
        padding: 20px;
    }

    .title {
        font-size: 24px;
    }

    .subtitle {
        font-size: 16px;
    }

    .hint-item {
        max-width: 95%;
    }
}
</style>